// extracted by mini-css-extract-plugin
export var pillWrapper = "_y7-0";
export var showOverflow = "_y7-1";